import React from "react";

interface AnalysisToolDropdownIconProps {
    icon: "Line" | "Polygon";
    className?: string;
}

export const AnalysisToolDropdownIcon = ({ icon, className }: AnalysisToolDropdownIconProps) => {
    const Line = (
        <svg className={className} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.925 3.47344V2H14V3.47344H15.925ZM17.925 0.499999C17.925 0.223857 17.7011 0 17.425 0H12.5C12.2239 0 12 0.223858 12 0.5V4.23873C11.9799 4.25587 11.9604 4.27394 11.9414 4.29292L4.29285 11.9415C4.27389 11.9604 4.25584 11.9799 4.23872 12H0.500002C0.22386 12 2.86102e-06 12.2239 2.86102e-06 12.5V16.9734C2.86102e-06 17.2496 0.22386 17.4734 0.500003 17.4734H5.425C5.70115 17.4734 5.925 17.2496 5.925 16.9734V13.1377L13.3556 5.70714C13.4265 5.63626 13.4845 5.5574 13.5296 5.47344H17.425C17.7011 5.47344 17.925 5.24959 17.925 4.97344V0.499999ZM3.925 14V15.4734H2V14H3.925Z"
                fill="currentColor"
            />
        </svg>
    );
    const Polygon = (
        <svg className={className} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.3125 2.3125V4.1875H16.1875V2.3125H14.3125ZM14 0.75H16.5C17.1641 0.75 17.75 1.33594 17.75 2V4.5C17.75 5.20312 17.1641 5.75 16.5 5.75H14.8203L13.7656 7.54688C13.8828 7.74219 14 8.01562 14 8.25V10.75C14 11.0234 13.8828 11.2969 13.7656 11.4922L14.8203 13.25H16.5C17.1641 13.25 17.75 13.8359 17.75 14.5V17C17.75 17.7031 17.1641 18.25 16.5 18.25H14C13.2969 18.25 12.75 17.7031 12.75 17V16.6875H5.25V17C5.25 17.7031 4.66406 18.25 4 18.25H1.5C0.796875 18.25 0.25 17.7031 0.25 17V14.5C0.25 13.8359 0.796875 13.25 1.5 13.25H1.8125V5.75H1.5C0.796875 5.75 0.25 5.20312 0.25 4.5V2C0.25 1.33594 0.796875 0.75 1.5 0.75H4C4.66406 0.75 5.25 1.33594 5.25 2V2.3125H12.75V2C12.75 1.33594 13.2969 0.75 14 0.75ZM11.8906 12H10.25C9.54688 12 9 11.4531 9 10.75V8.25C9 7.58594 9.54688 7 10.25 7H11.8906L12.9453 5.24219C12.8281 5.04688 12.75 4.77344 12.75 4.5V4.1875H5.25V4.5C5.25 5.20312 4.66406 5.75 4 5.75H3.6875V13.25H4C4.66406 13.25 5.25 13.8359 5.25 14.5V14.8125H12.75V14.5C12.75 14.2656 12.8281 13.9922 12.9453 13.7969L11.8906 12ZM1.8125 16.6875H3.6875V14.8125H1.8125V16.6875ZM14.3125 16.6875H16.1875V14.8125H14.3125V16.6875ZM1.8125 4.1875H3.6875V2.3125H1.8125V4.1875ZM10.5625 8.5625V10.4375H12.4375V8.5625H10.5625Z"
                fill="currentColor"
            />
        </svg>
    );

    switch (icon) {
        case "Line":
            return Line;
        case "Polygon":
            return Polygon;
        default:
            return Line;
    }
};
